import { Link } from 'react-router-dom';
import { useState, useEffect, useRef } from 'react';
export default function Navbar() {
  const [open, setOpen] = useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <nav style={styles.nav}>
      <div style={styles.left}>
        <img
          src="/PeakLabsPro_Logo_256x192.png"
          alt="logo"
          style={styles.logo}
        />
      </div>

      <div style={styles.links}>
        <Link style={styles.link} to="/">
          Home
        </Link>

        <div style={styles.dropdown} ref={dropdownRef}>
          {' '}
          <span style={styles.link} onClick={() => setOpen(!open)}>
            Solutions ▾
          </span>
          {open && (
            <div style={styles.dropdownMenu}>
              <Link
                style={styles.dropdownItem}
                to="/solutions/shop_management"
                onClick={() => setOpen(false)}
              >
                {' '}
                Shop Management
              </Link>
              {/* <Link
                style={styles.dropdownItem}
                to="/solutions/property_management"
                onClick={() => setOpen(false)}
              >
                Property Management
              </Link> */}
            </div>
          )}
        </div>
        <Link style={styles.link} to="/support">
          Support
        </Link>
        <Link style={styles.cta} to="/contact">
          Contact
        </Link>
      </div>
    </nav>
  );
}

const styles = {
  nav: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 50px',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    width: '100%',
    boxSizing: 'border-box',
    background: 'rgba(15,23,42,0.75)',
    backdropFilter: 'blur(12px)',
    color: '#fff',
    zIndex: 1000,
  },
  left: { display: 'flex', alignItems: 'center' },
  logo: { height: '80px', marginRight: '10px' },
  brand: { fontWeight: 'bold', fontSize: '18px' },
  links: { display: 'flex', alignItems: 'center' },
  link: {
    marginLeft: '25px',
    color: '#fff',
    cursor: 'pointer',
    textDecoration: 'none',
  },
  dropdown: { position: 'relative' },
  dropdownMenu: {
    position: 'absolute',
    top: '45px',
    left: 0,
    minWidth: '240px', // makes it wider
    background: '#1e293b',
    padding: '12px 0',
    borderRadius: '10px',
    boxShadow: '0 15px 35px rgba(0,0,0,0.4)',
  },

  dropdownItem: {
    display: 'block',
    color: '#fff',
    padding: '10px 20px',
    textDecoration: 'none',
    whiteSpace: 'nowrap', // prevents line breaks
  },
  cta: {
    marginLeft: '30px',
    padding: '10px 18px',
    background: '#ff6600',
    borderRadius: '6px',
    color: '#fff',
    textDecoration: 'none',
  },
};
